import { createContext, useContext, useState } from "react";

const ModalContext = createContext();

export function ModalProvider({ children }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    if (typeof window.fbq === "function") {
      window.fbq("track", "Lead");
    }
    if (typeof window.gtag === "function") {
      window.gtag("event", "generate_lead", { event_category: "engagement", event_label: "check_my_date" });
    }
    window.open("https://www.weddingvideo.co.uk/contact", "_blank", "noopener");
  };

  return (
    <ModalContext.Provider value={{ isModalOpen, openModal, closeModal: () => setIsModalOpen(false) }}>
      {children}
    </ModalContext.Provider>
  );
}

export function useModal() {
  return useContext(ModalContext);
}
